export const REASON_WITH_PAID = 'Con Goce de Haber'
export const REASON_UN_PAID = 'Sin Goce de Haber'
